import * as React from "react"
// helper
import { ISvgIcons } from "./helper"

export const GridIcon: React.FC<ISvgIcons> = ({ className = "", ...rest }) => (
    <svg
        viewBox="0 0 25 25"
        className={`${className}`}
        stroke="currentColor"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...rest}
    >
        <path d="M5.75 10.25H7.75C9.75 10.25 10.75 9.25 10.75 7.25V5.25C10.75 3.25 9.75 2.25 7.75 2.25H5.75C3.75 2.25 2.75 3.25 2.75 5.25V7.25C2.75 9.25 3.75 10.25 5.75 10.25Z" />
        <path d="M17.75 10.25H19.75C21.75 10.25 22.75 9.25 22.75 7.25V5.25C22.75 3.25 21.75 2.25 19.75 2.25H17.75C15.75 2.25 14.75 3.25 14.75 5.25V7.25C14.75 9.25 15.75 10.25 17.75 10.25Z" />
        <path d="M17.75 22.25H19.75C21.75 22.25 22.75 21.25 22.75 19.25V17.25C22.75 15.25 21.75 14.25 19.75 14.25H17.75C15.75 14.25 14.75 15.25 14.75 17.25V19.25C14.75 21.25 15.75 22.25 17.75 22.25Z" />
        <path d="M5.75 22.25H7.75C9.75 22.25 10.75 21.25 10.75 19.25V17.25C10.75 15.25 9.75 14.25 7.75 14.25H5.75C3.75 14.25 2.75 15.25 2.75 17.25V19.25C2.75 21.25 3.75 22.25 5.75 22.25Z" />
    </svg>
)
